<template>
	<div v-if="user.subscription">
		<div id="fb-root" />
		<h3
			v-html="`Invita i tuoi amici a cena!`"
		/>
		<p
			v-html="`Regala ${ invitedAmound * invitedCount } € per i loro primi ordini e ottieni ${ rewardAmount * rewardCount } € per le tue cene.`"
		/>
		<p
			v-html="`Condividere è facile! Invita i tuoi amici su Quomi tramite email o condividi il tuo codice di invito sui canali che preferisci (Messenger, Whatsapp, Social).`"
		/>
		<p
			v-html="`Per ogni amico che inviti e che effettua il primo ordine, riceverai ${ rewardCount } buoni sconto del valore di <nobr>${ rewardAmount } €!</nobr>`"
		/>
		<p
			v-html="`Non c’è limite al numero di inviti che puoi inviare. I tuoi crediti disponibili appaiono automaticamente nella pagina del tuo profilo.`"
		/>
		<p>
			<router-link
				:to="{name: 'legal-referral'}"
				class="link-detail"
				v-html="`Termini e condizioni degli inviti`"
			/>
		</p>

		<br>
		<div class="flex flex-wrap align-items-center mb-5">
			<h3
				class="share-title m-0 pr-5"
				v-html="`Condividi il tuo link: `"
			/>
			<social-share
				invite-friend
				:facebook="`${url}`"
				:whatsapp="`Vai su Quomi e ricevi ${ invitedAmound * invitedCount }€ sulle tue prime 2 spese a casa. ${url}`"
				:mail="{ subject: `Ecco per te ${ invitedAmound * invitedCount }€ da spendere su Quomi!`, body: `Vai su Quomi e ricevi ${ invitedAmound * invitedCount }€ sulle tue prime 2 spese a casa. ${url}` }"
				:copyString="url"
				:size="`small`"
			/>
		</div>

		<div
			class='flex share-btn'
		>
			<input
				class="ref form-control m-0 mr-5"
				type="text"
				id="link"
				:value="url"
			>
			<CTA
				:content="`Copia`"
				:size="`small`"
				@click="copy()"
				class="mx-0"
			/>
			
		</div>
		<p
			v-html="`oppure`"
			class="my-3"
		/>
		<form
			method='POST'
			id="invite-friend"
			@submit.prevent="invite()"
		>
			<div class='flex invite-btn'>
				<input
					type='email'
					v-model="email"
					class='form-control mr-5'
					placeholder="Inserisci l'indirizzo e-mail"
					name='email'
				>
				<CTA
					:content="`Manda il tuo invito`"
					type='submit'
					:size="`small`"
					class="mx-0"
				/>
			</div>
			<p
				class="google-import"
				v-if="!$mq.isWV()"
			>
				Importare i contatti:
				<img src="../../assets/img/gmail.png" width="17" class="open-google-contacts">
				&nbsp;<span class="gmail" @click="openGmail()">Gmail</span>

			</p>
			<p
				class="google-import"
				v-if="$mq.isWV()"
			>
				<a
					class="link-detail"
					:href="`share:${url}`"
					v-html="`Condividi`"
				/>
			</p>

			<flash
				:flash="flash"
				:state="state"
			/>
		</form>
		
		<modal-gmail-import
			ref="gmailModal"
			@success="success"
		/>
	</div>
</template>

<script>
import { UserApi } from '../../api/UserApi'
import ModalGmailImport from './ModalGmailImport'
import Flash from '../Parts/Flash'
import CTA from '../Elements/CTA'
import SocialShare from '../SocialShare/SocialShare'
import { configStore } from '../../store/configStore' 

export default {

	components: {
		Flash,
		ModalGmailImport,
		SocialShare
	},

	data () {
		return {
			email: null,
			flash: null,
			state: null,
			configStore: configStore.state
		}
	},

	computed: {
		user () {
			return this.$root.user
		},

		url () {
			return `https://quomi.it/?ref=${this.user.ref}`
		},

		rewardAmount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_amount']
				? this.configStore.config['quomi.refer.reward_amount']
				: this.configStore.default.reward_amount
		},

		invitedAmound () {
			return this.configStore.config && this.configStore.config['quomi.refer.invited_amount']
				? this.configStore.config['quomi.refer.invited_amount']
				: this.configStore.default.invited_amount
		},

		rewardCount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_count']
				? this.configStore.config['quomi.refer.reward_count']
				: this.configStore.default.reward_amount
		},

		invitedCount () {
			return this.configStore.config && this.configStore.config['quomi.refer.invited_count']
				? this.configStore.config['quomi.refer.invited_count']
				: this.configStore.default.invited_amount
		},
	},

	methods: {
		invite () {
			this.flash = null

			var params = {
				email: this.email
			}

			var um = new UserApi()
			um.invite(params)

			.then(response => {
				this.success()
			})

			.catch(response => {
				this.flash = response.body.message
				this.state = 'error'
			})
		},

		copy () {
			document.getElementById('link').select()
			document.getElementById('link').setSelectionRange(0, 9999)
			document.execCommand('copy')
		},

		success () {
			this.flash = 'Email inviata correttamente!'
			this.state = 'success'
		},

		openGmail () {
			this.$refs.gmailModal.open()
		},
	},

	mounted () {
		configStore.loadConfig()
	}
}

</script>

<style scoped>
	.gmail {
		text-decoration: underline;
		cursor: pointer;
	}

	.flex input {
		flex-grow: 1;
		width: auto;
	}

	@media (max-width: 768px) {
		.share-btn,
		.invite-btn {
			flex-wrap: wrap;
			margin-bottom: 5px;
		}

		.share-btn input,
		.invite-btn input {
			width: 100%;
		}

		.share-title,
		.ref {
			margin-bottom: 10px !important;
		}
}
</style>
